import {Component} from 'preact';
import throttleToFrame from '~/utils/events/throttleToFrame';
import {setTooltipVisibility} from './Store/creators/visualData';
import {dispatch} from './Store/index';

/**
 * Component State.
 */
interface AbstractVisualStepState
{
	/**
	 * Соотношение сторон меньше изображения?
	 */
	aspectRatioLessThanImage: boolean;
}

/**
 * Абстрактный компонент шага визуального выбиратора.
 */
abstract class AbstractVisualStep<PropsType, StateType extends AbstractVisualStepState>
	extends Component<PropsType, StateType>
{
	/**
	 * Соотношение сторон изображения на карте.
	 */
	public static readonly IMAGE_ASPECT_RATIO = 16 / 9;
	/**
	 * Класс, назначаемый при меньшем соотношении сторон.
	 */
	public static readonly CLASS_INVERT_ASPECT = 'invert-aspect';
	/**
	 * Элемент карты.
	 */
	protected mapContainer: HTMLElement;
	/**
	 * Количество прикосновений к области.
	 */
	protected areaTouchCount: number = 0;
	/**
	 * Область, по которой было прикосновение.
	 */
	protected areaTouchTarget: Element | null = null;
	
	/**
	 * Абстрактный компонент шага визуального выбиратора.
	 */
	public constructor( props: PropsType )
	{
		super( props );
		
		this.setState(
			{
				aspectRatioLessThanImage: false,
			},
		);
		
		this.onWindowResize = throttleToFrame( this.onWindowResize );
	}
	
	/**
	 * Rendered component mounted to the DOM.
	 */
	public componentDidMount(): void
	{
		window.addEventListener( 'resize', this.onWindowResize );
		this.onWindowResize();
	}
	
	/**
	 * Before component will be unmounted and destroyed.
	 */
	public componentWillUnmount(): void
	{
		window.removeEventListener( 'resize', this.onWindowResize );
	}
	
	/**
	 * Сохраняет ссылку на элемент карты.
	 */
	protected refMapContainer = ( element: HTMLElement ): void =>
	{
		this.mapContainer = element;
	}
	
	/**
	 * При отведении курсора с области.
	 */
	protected onAreaMouseLeave = (): void =>
	{
		dispatch( setTooltipVisibility( false ) );
	}
	
	/**
	 * При нажатии на область.
	 */
	protected onAreaTouch = ( event: Event ): void =>
	{
		const target = event.target as Element;
		const targetId = target.getAttribute( 'data-target' );
		
		if ( !targetId )
		{
			return;
		}
		
		if ( this.areaTouchTarget !== target )
		{
			this.areaTouchCount = 0;
		}
		
		this.areaTouchCount++;
		this.areaTouchTarget = target;
	}
	
	/**
	 * Добавляет класс в зависимости от соотношения сторон элемента карты.
	 */
	private onWindowResize = (): void =>
	{
		const map = this.mapContainer;
		
		if ( !map )
		{
			return;
		}
		
		const ratio = map.offsetWidth / map.offsetHeight;
		const aspectRatioLessThanImage = ( ratio < AbstractVisualStep.IMAGE_ASPECT_RATIO );
		
		this.setState( {aspectRatioLessThanImage} );
	}
}

/**
 * Module.
 */
export {
	AbstractVisualStep as default,
	AbstractVisualStepState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/AbstractVisualStep.ts